import { Link } from "react-router-dom";
import { deleteProduct } from "../../../services/Rest.jsx";
import Button from "../button/Button.jsx";
import Table from "./Table.jsx";

const TableProducts = ({ data, error, loading, refetch }) => {
  const columns = [
    { header: "Código", accessor: "cod" },
    { header: "Nombre", accessor: "name" },
    { header: "Código N.C.", accessor: "nc" },
    { header: "Capacidad", accessor: "capacity" },
    { header: "Graduación", accessor: "percentage" },
    { header: "Código Impositivo", accessor: "codigo_impositivo" },
    { header: "Clave", accessor: "clave_product" },
    { header: "EPC", accessor: "excise_product_code" },
    {
      header: "",
      render: (row) => {
        return (
          <Link
            to={`/products/${row.id}/edit`}
            className="hover:underline text-blue-600"
          >
            Edit
          </Link>
        );
      },
    },
    {
      header: "",
      render: (row) => {
        return <Button onClick={() => deleteOnClick(row.id)} className="hover:underline text-blue-600">Delete</Button>;
      },
    },
    { header: "", render: (row) => {} },
  ];

  const deleteOnClick = async (id) => {
    try {
      await deleteProduct(id);
      await refetch();
    } catch (e) {
      console.log(e.response.data);
    }
  };

  if (loading) return <div>Cargando Productos...</div>;
  if (error) return <div className="text-red-600">Error: {error.response.data.detail}</div>;
  if (!data || data.length === 0) return <div>No se ha encontrado ningún producto</div>;

  const sortedData = [...data].sort((a, b) => {
    return Number(a.cod) - Number(b.cod);
  });

  return (
    <div>
      <Table columns={columns} data={sortedData} />
    </div>
  );
};

export default TableProducts;
